// The one error type the contract layer throws.

/**
 * A non-2xx response from the backend. Carries the HTTP `status`, the parsed
 * `body` (JSON when the server sent JSON, else the raw text), and a `message`
 * lifted from the body's `message` field when present (else the status text).
 * Every API method rejects with this on a non-ok response, so callers can
 * branch on `err instanceof ApiError` and read `err.status` uniformly.
 */
export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, message: string, body: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}
